const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Colonization extends Technology {
    constructor(age, techName, scienceCost, militaryBonus, colonizationBonus){
        super(
            age,
            Colonization.GetType(),
            techName,
            scienceCost,
            null,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.militaryCalculationDelegate.push({
                            Source: this,
                            Action: () => militaryBonus,
                        });
                        playerState.colonizationBonusCalculationDelegate.push({
                            Source: this,
                            Action: () => colonizationBonus,
                        });
                    }
            }
        )
    }
    static GetType = () => TechnologyTypes.Special.Colonization;
}

class Cartography extends Colonization {
    constructor(){
        super(Age.Age1, TechnologyNames.Special.Cartography, 4, 1, 2)
    }

    static GetInstance = () => new Cartography();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Special.Cartography;
}

class Navigation extends Colonization {
    constructor(){
        super(Navigation.GetAge(), Navigation.GetName(), 6, 2, 3)
    }

    static GetInstance = () => new Navigation();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Special.Navigation;
}

class Satellites extends Colonization {
    constructor(){
        super(Satellites.GetAge(), Satellites.GetName(), 8, 3, 4)
    }

    static GetInstance = () => new Satellites();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Special.Satellites;
}

module.exports = {
    Cartography,
    Navigation,
    Satellites
}